module.exports = __webpack_public_path__ + "static/media/face@3x.bb801708.png";